module.exports = __webpack_public_path__ + "img/Public.ca7eeede.png";